import { render, staticRenderFns } from "./myCustomerModel.vue?vue&type=template&id=93e2daf0&scoped=true&lang=pug&"
import script from "./myCustomerModel.vue?vue&type=script&lang=js&"
export * from "./myCustomerModel.vue?vue&type=script&lang=js&"
import style0 from "./myCustomerModel.vue?vue&type=style&index=0&id=93e2daf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e2daf0",
  null
  
)

export default component.exports